const getDistinctValues = <T, K extends keyof T>(
  array: T[],
  field: K
): string[] => {
  const values = new Set<string>();
  array.forEach((item) => {
    const fieldValue = item[field];
    if (Array.isArray(fieldValue)) {
      fieldValue.forEach((subItem) => {
        if (subItem !== undefined) {
          values.add(subItem.toString());
        }
      });
    } else if (fieldValue !== undefined && fieldValue !== null) {
      values.add(String(fieldValue));
    }
  });
  return Array.from(values);
};

export default getDistinctValues;
